<template>
    <div
        :class="[
            'z-10',
            { 'pt-20 sm:pt-24': paddingTop },
            { 'pb-16 sm:pb-24': paddingBottom },
            { 'pt-10 sm:pt-10': paddingTopHalf },
            { 'pb-10 sm:pb-10': paddingBottomHalf },
            { 'flex flex-col min-h-[calc(100vh-90px)] bg-red-200': fullscreen },
            {
                'bg-[url(/images/hero-background.jpg)] w-full bg-cover bg-center bg-no-repeat':
                    heroBackground,
            },
            {
                'z-0 w-screen h-full bg-[url(/images/section-background.svg)] bg-cover bg-repeat-y': false,
            },
            {
                '!bg-repeat-y': heroBackground && repeatBackground,
            },
        ]"
    >
        <slot></slot>
    </div>
</template>
<script>
export default {
    props: {
        paddingTop: {
            type: Boolean,
        },
        paddingBottom: {
            type: Boolean,
        },
        paddingTopHalf: {
            type: Boolean,
        },
        paddingBottomHalf: {
            type: Boolean,
        },
        fullscreen: {
            type: Boolean,
        },
        heroBackground: {
            type: Boolean,
        },
        sectionBackground: {
            type: Boolean,
        },
        repeatBackground: {
            type: Boolean,
        },
    },
};
</script>
